import React, { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import SearchIcon from '@mui/icons-material/Search';
import './SearchButton.css';

/**
 * SearchButton component provides a styled button that appears continuous with an input field
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Callback function when button is clicked
 * @param {boolean} props.disabled - Whether the button is disabled
 */
function SearchButton({ onClick, disabled = false }) {
  const { theme } = useContext(ThemeContext);

  return (
    <button
      type="button"
      className={`search-button ${theme}`}
      onClick={onClick}
      disabled={disabled}
      aria-label="Search"
    >
      <SearchIcon />
    </button>
  );
}

export default SearchButton;